// extracted by mini-css-extract-plugin
export default {"background":"qI","weightImage":"rI","drinkImage":"sI","content":"tI","rtbLeft":"uI","rtbRight":"vI","rtbLeftMobile":"wI","imageContainer":"xI","rtbBox":"yI","line":"zI","rtbDesktop":"AI"};
    if(module.hot) {
      // 1715091679810
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  